export const ImageCircle = {
  bindings: {
    src: '<',
  },

  template: `
    <div class="image-circle">
      <image-background src="$ctrl.src"></image-background>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Image/Circle.js